"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const cotopaxi_1 = require("@as/cotopaxi");
const useZitcha_1 = require("../../hooks/useZitcha");
const andes_react_1 = require("@yonderland/andes-react");
function ZitchaBannerContainer({ location, banners }) {
    const { collectClick } = (0, useZitcha_1.useZitcha)();
    const handleClick = (banner) => () => tslib_1.__awaiter(this, void 0, void 0, function* () {
        yield collectClick({
            adFormat: 'native_banner',
            adId: banner.ad_id,
            placementId: `${location}-${banner.placement}`,
        }).finally(() => {
            var _a, _b;
            window.location.href = (banner.creative.url || ((_b = (_a = banner.creative) === null || _a === void 0 ? void 0 : _a.cta) === null || _b === void 0 ? void 0 : _b.url));
        });
    });
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: banners.map(banner => {
            var _a, _b, _c, _d, _e;
            return ((0, react_1.createElement)("div", Object.assign({ onClick: handleClick(banner) }, (0, andes_react_1.getInteractiveProps)({ callback: handleClick(banner), role: 'link' }), { key: banner.ad_id }),
                (0, jsx_runtime_1.jsx)(cotopaxi_1.Teaser, { image: {
                        src: ((_a = banner.creative.desktop) === null || _a === void 0 ? void 0 : _a.image) || banner.creative.image,
                        alt: 'BANNER',
                        width: ((_b = banner.creative.desktop) === null || _b === void 0 ? void 0 : _b.width) || banner.creative.width,
                        height: ((_c = banner.creative.desktop) === null || _c === void 0 ? void 0 : _c.height) || banner.creative.height,
                    }, title: (_d = banner.creative.headline) === null || _d === void 0 ? void 0 : _d.text, text: (_e = banner.creative.subtitle) === null || _e === void 0 ? void 0 : _e.text, CTAs: banner.creative.cta
                        ? [
                            {
                                text: banner.creative.cta.text,
                                onClick: handleClick(banner),
                                variant: cotopaxi_1.ButtonVariant.INVERSE,
                                shape: cotopaxi_1.ButtonShape.PILL,
                            },
                        ]
                        : undefined, imageOverlay: cotopaxi_1.TeaserImageOverlay.DARK_66, innerSpacing: { padding: 4 } })));
        }) }));
}
exports.default = ZitchaBannerContainer;
